// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_ct","advertCardPhoto__image":"c-a_cu"};